export async function registerWorker(institutionId: string, version: string) {
    if (!('serviceWorker' in navigator)) {
        throw new Error('Service workers not supported.');
    }

    if (!institutionId || !version) {
        throw new Error('Could not initialize service worker. Missing data.');
    }

    try {
        const registration = await navigator.serviceWorker.register('/pwa/service-worker.js', {
            scope: `/pwa/${institutionId}`,
            type: 'module',
        });
        // eslint-disable-next-line no-console
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
        registration.active?.postMessage({
            version,
        });

        return registration;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('ServiceWorker registration failed: ', err);
    }

    return undefined;
}
